import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Container } from 'reactstrap';

import Header from './header';
import Sidebar from './sidebar/';
import Breadcrumb from './breadcrumb';
import { getRoutes } from '../../routes';

import Lang from '../../languages';
import Config from '../../config';

class App extends Component {
 constructor(props) {
  super(props);
  this.reload = this.reload.bind(this);
  this.state = {
   show: true,
   lastState: null
  };
 }

 reload(lastState) {
  this.setState({ show: false, lastState }, () => {
   this.setState({ show: true })
  })
 }

 render() {
  return (
   <div className="app">
    <Header {...this.props} />
    <div className="app-body">
     <Sidebar {...this.props} />
     <main className="main">
      <Breadcrumb {...this.props} />
      <Container fluid>
       <Switch>
        {
         getRoutes(this.props.session.language).map((route, idx) => {
          return this.state.show
          ? route.component
           ? route.path == '/settings'
            ? this.props.session.permissions.users['administrators']
             ? <Route key={idx} path={route.path} exact={route.exact} render={props => (<route.component {...this.props} />)} />
             : null
            : <Route key={idx} path={route.path} exact={route.exact} render={props => (<route.component {...this.props} reload={this.reload} lastState={this.state.lastState} />)} />
           : null
           : null
         })
        }
        <Redirect from="/" to={Config.defaultPage} />
       </Switch>
      </Container>
     </main>
    </div>
   </div>
  );
 }
}

export default App;



// WEBPACK FOOTER //
// ./websources/containers/DefaultLayout/index.js